import { MijnRoute } from '../../mijn-navigatie.model';

export const COLLECTION_ADD_PERMISSION: MijnRoute = {
    path: 'toestemming-toevoegen',
    navigationEvent: 'toIncassoAddPermission',
    regex: /^\/incasso\/toestemming-toevoegen$/,
    webcomponent: 'mijn-transacties-incasso-webcomponent',
    internalPath: '/toestemming-toevoegen'
};
